$('[slider]').each(function () {
    var $element = $(this);
    var name = $element.attr('slider');
    initSlider(name, $element);
});

function initSlider(name, $element) {
    switch (name) {
        case "acco-gallery":
            // see: accoCtrl.js
            break;
        case "content":
            if ($element.find('.swiper-wrapper').children().length <= 1) {
                $element.find('.slider-arrows').remove();
                return;
            }

            new Swiper($element[0], {
                // for better swipe / click
                resistance: true,
                resistanceRatio: 0.99,

                pagination: {
                    el: '.swiper-pagination',
                },

                navigation: {
                    nextEl: $element.find('.slider-next')[0],
                    prevEl: $element.find('.slider-prev')[0],
                },
                init: function () {
                    $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                }
            });

            break;
        case "room-images":
            var swiper = new Swiper($element[0], {
                // for better swipe / click
                resistance: true,
                resistanceRatio: 0.99,

                loop: true,
                autoplay: { delay: 7000 },

                effect: 'fade',

                pagination: {
                    el: $element.find('.swiper-pagination')[0],
                    dynamicBullets: true,
                },

                on: {
                    init: function () {
                        $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                    }
                }
            });

            break;

        case "ads-premium-teasers":
            new Swiper($element[0], {
                // for better swipe / click
                spaceBetween: 15,
                navigation: {
                    nextEl: $element.find('.slider-button-next')[0],
                    prevEl: $element.find('.slider-button-prev')[0],
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                    },
                    769: {
                        slidesPerView: 2,
                    },
                    1000: {
                        slidesPerView: 3,
                    }
                },
                init: function () {
                    $element.find('.lazyloading').removeClass('lazyloading').addClass('lazyload');
                }
            });

            break;
        default:
    }
}
